import React from 'react'
import FormatCurrency from '../helpers/FormatCurrency';

function Radio({ amount, title, ...rest }) {
    return (
        <label className="cursor-pointer">
            <input {...rest} type="radio" className="peer sr-only" name="customise" />

            <div className="max-w-xl rounded-md bg-white py-2 px-3 text-gray-600 ring-1 
            ring-gray-100 transition-all hover:shadow peer-checked:ring-black 
            peer-checked:ring-offset-1">
                <div className="flex flex-col gap-1">
                    <div className="space-y-0">
                        <p className="text-black text-xs uppercase tracking-wide font-medium font-serif">{title}</p>
                        <div className="text-gray-500 text-xs"><FormatCurrency amount={amount} /></div>
                    </div>
                </div>
            </div>
        </label>

    )
}

export default Radio